import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes';
import Middleware from '@/router/middleware/index';

const AuthOnly: FC = () => {
  const { isLoading, session } = useAuthContext();

  return (
    <Middleware isLoading={isLoading}>
      {session ? <Outlet /> : <Navigate to={Routes.LOGIN} replace />}
    </Middleware>
  );
};

export default AuthOnly;
